<template>
<el-card class="nopadd" >
  <div class="navbar">
    <hamburger :is-active="sidebar.opened" class="hamburger-container" @toggleClick="toggleSideBar" />
    <breadcrumb class="breadcrumb-container" />
    <noteCompTitle ></noteCompTitle>

    <div class="right-menu">
      <span style="margin-right:10px;font-size:16px;color:#515151"><img style="vertical-align: middle;margin-right:6px;margin-top:-2px;width: 28px;height:28px" src="@/images/recog2.png" alt="">{{rolename}}</span>
      <el-dropdown class="avatar-container" trigger="click">
        <div class="avatar-wrapper">
          <img :src="avatar+'?imageView2/1/w/80/h/80'" class="user-avatar">
          <i class="el-icon-caret-bottom" />
        </div>
        <el-dropdown-menu slot="dropdown" class="user-dropdown">
          <el-dropdown-item  @click.native="personInfo">
            <span style="display:block;">个人信息</span>
          </el-dropdown-item>
          <el-dropdown-item  @click.native="logout">
            <span style="display:block;">退出</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
  </el-card>
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'

import noteCompTitle from '@/components/common/noteTitle'

import Cookies from 'js-cookie'
export default {
  components: {
    Breadcrumb,
    Hamburger,
    noteCompTitle,
  },
  
  computed: {
    ...mapGetters([
      'sidebar'
      // 'avatar',
      // 'platform'
    ])
  },
  data() {
    return {
      avatar: '',
      rolename:'',
      isShowSidebar: true,
    }
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar')
    },
    logout() {
      // await this.$store.dispatch('user/logout');
      localStorage.removeItem('Authorization')
      // sessionStorage.removeItem('Authorization')
      document.cookie = "Authorization=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
      localStorage.removeItem('role')
      localStorage.removeItem('uid')
      this.$router.push(`/login?redirect=${this.$route.fullPath}`)
    },
    personInfo() {
      // alert(123)
      // this.$router.push(`/personInfo`)
      this.$router.push({path:'/manage/personInfo'})
    },
    // gettoken(){
    //   // this.$store.dispatch('user/setAccount')
    // }
    userInfo() {

      var getTok = localStorage.getItem('Authorization');
      // var parTok=JSON.parse(getTok);
      // console.log( parTok.access_token,"拿到缓存");
      // var paramsTok=parTok.access_token;
      this.axios.get('api/auth/userinfo').then(res=>{
        // console.log(res, 'touxiang')
        this.avatar = res.data.avatar;
        if(res.data.organization){
          this.rolename=res.data.organization.title;
          if(res.data.organization.config && res.data.organization.config.checkin_effective_interval){
            localStorage.setItem('clockingTime', res.data.organization.config.checkin_effective_interval)
          }
        }
        
        var subinfo = res.data.role
        localStorage.setItem('uid', res.data.id)
        localStorage.setItem('oid', res.data.oid)
        localStorage.setItem('username', res.data.name)
        localStorage.setItem('role', JSON.stringify(subinfo));
        localStorage.setItem('permission', res.data.permission);
        localStorage.setItem('product_org_type', res.data.organization.org_type);
        let runStage = ''
        if(res.data.organization && res.data.organization.run_stage){
          runStage = res.data.organization.run_stage
          localStorage.setItem('runStage', runStage);
        }
        if(res.data.organization && res.data.organization.product_version){ // 产品版本 专业版 基础版 标准版
          localStorage.setItem('product_version', res.data.organization.product_version)
        }
        if(res.data.is_admin=='1'){
          localStorage.setItem('admin', true);
        }else{
          localStorage.setItem('admin', false);
        }
        
      })
    },
    // 侧边栏是否隐藏
    getSidebarShowFun() {
      this.isShowSidebar = Cookies.get('isShowSidebar')
    }
  },
  created() {
    let orgTypeData = JSON.parse(localStorage.getItem('orgType'))
    let pageTitle = ''
    if(orgTypeData && orgTypeData.title){
      pageTitle = orgTypeData.title
    }
    document.title = pageTitle

  },
  mounted() {
    
    
    this.userInfo()
    // var that=this;
    // console.log( that.$store.getter.avatar,"拿到了吗")
    // console.log( that.$store,"拿到了吗")
  }
}
</script>

<style lang="scss" scoped>
.nopadd {
  .navbar {
    height: 50px;
    overflow: hidden;
    position: relative;
    background: #fff;
    box-shadow: 0 1px 4px rgba(0,21,41,.08);

    .hamburger-container {
      line-height: 46px;
      height: 100%;
      float: left;
      cursor: pointer;
      transition: background .3s;
      -webkit-tap-highlight-color:transparent;

      &:hover {
        background: rgba(0, 0, 0, .025)
      }
    }

    .breadcrumb-container {
      float: left;
    }

    .right-menu {
      float: right;
      height: 100%;
      line-height: 50px;
      display: flex;
      &:focus {
        outline: none;
      }

      .right-menu-item {
        display: inline-block;
        padding: 0 8px;
        height: 100%;
        font-size: 18px;
        color: #5a5e66;
        vertical-align: text-bottom;

        &.hover-effect {
          cursor: pointer;
          transition: background .3s;

          &:hover {
            background: rgba(0, 0, 0, .025)
          }
        }
      }

      .avatar-container {
        margin-right: 30px;

        .avatar-wrapper {
          margin-top: 5px;
          position: relative;

          .user-avatar {
            cursor: pointer;
            width: 40px;
            height: 40px;
            border-radius: 10px;
          }

          .el-icon-caret-bottom {
            cursor: pointer;
            position: absolute;
            right: -20px;
            top: 25px;
            font-size: 12px;
          }
        }
      }
    }
  }
}
</style>
<style >
  .nopadd .el-card__body{
  padding: 0px;
  /* border-radius: 8px; */
}
</style>
